import {
  AppBar,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  IconButton,
  Stack,
  TextField,
  Toolbar,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

import { styled, useTheme } from "@mui/material/styles";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "src/app/main/utilities/AgGridTable";
import DirectoryFilter from "./DirectoryFilter";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FormPageHeader from "../../utilities/FormPageHeader";
import { Box } from "@mui/system";
import "../expense-claim/expenseClaim.css";

const expenseListURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;
// const ActionRenderer = (props) => {
//   return (
//     <div className="flex item-center">
//       <Button color="warning" variant="contained" sx={{ mr: 1 }}>
//         View
//       </Button>
//       <Button color="warning" variant="contained" sx={{ mr: 1 }}>
//         {" "}
//         Edit
//       </Button>
//       <Button color="warning" variant="contained">
//         {" "}
//         Print
//       </Button>
//     </div>
//   );
// };
const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));
const payGroupOptions = [
  { label: "ALL", value: "ALL" },
  { label: "Nolte FZE", value: "Nolte FZE" },
  { label: "FREE LANCE", value: "FREE LANCE" },
  { label: "IT CONSULTANT", value: "IT CONSULTANT" },
];
const ExitProcess = () => {
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const [rowData, setRowData] = useState([
    {
      code: "20",
      empName: "Employee 20",
      designation: "Sales",
      separationType: "Terminated",
      separationDate: "31-10-2023",
      lastWorkingDay: "30-10-2023",
      totalService: "0 Year(s) 10 month(s) 15 day(s) (318 Days)",
      netEndOfServicePay: "2,500.00",
      amountPaid: "2,500.00",
      status: "In Active",
      journalVoucher: "22100345",
      bankPayment: "221100258",
    },
    {
      code: "19",
      empName: "Employee 19",
      designation: "Sales",
      separationType: "Resigned",
      separationDate: "31-08-2023",
      lastWorkingDay: "30-09-2023",
      totalService: "0 Year(s) 10 month(s) 15 day(s) (318 Days)",
      netEndOfServicePay: "12,500.00",
      amountPaid: "12,500.00",
      status: "On Process",
      journalVoucher: "22100345",
      bankPayment: "221100258",
    },
  ]);

  const [rowDataEmp, setRowDataEmp] = useState([
    { code: 18, empName: "Employee 18", separationType: "Terminated" },
  ]);

  const [columnEmp, setColumnEmp] = useState([
    {
      field: "code",
      headerName: "Employee Code",
      filter: "agNumberColumnFilter",
    },
    {
      field: "empName",
      headerName: "Employee Name",
    },
    {
      field: "separationType",
      headerName: "Separation Type",
    },
  ]);

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "code",
      headerName: "Code",
      filter: "agNumberColumnFilter",
    },
    {
      field: "empName",
      headerName: "Employee Name",
    },

    {
      field: "designation",
      headerName: "Designation",
    },
    {
      field: "separationType",
      headerName: "Separation Type",
    },
    {
      field: "separationDate",
      headerName: "Separation Date",
    },
    {
      field: "lastWorkingDay",
      headerName: "Last Working Day",
    },
    {
      field: "totalService",
      headerName: "Total Service",
    },
    {
      field: "netEndOfServicePay",
      headerName: "Net End Of Service Pay",
    },
    {
      field: "amountPaid",
      headerName: "Amount Paid",
    },
    {
      field: "status",
      headerName: "Status",
    },
    {
      field: "journalVoucher",
      headerName: "Journal Voucher",
    },
    {
      field: "bankPayment",
      headerName: "Bank Payment",
    },
  ]);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(expenseListURL);
      // let expenseClaimList = list.data._embedded.expenses;
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);
  const onRowDoubleClicked = (params) => {
    navigate("/payroll/employee/profile");
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };
  const getContextMenuItems = (event) => {
    var result =
      event.node.data.status === "On Process"
        ? [
            {
              name: "View",
              icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
              action: (props) => {
                navigate(
                  `/exit-process/emp-details?val=view&id=${event.node.data.code}`
                );
              },
            },
            {
              name: "Payment",
              icon: '<span><i class="material-icons" style="font-size: 18px">payment</i></span>',
              action: (props) => {
                // navigate(
                //   `/payroll/salary/revision/action?val=view&id=${event.node.data.code}`
                // );
              },
            },
            {
              name: "Edit",
              icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
              action: (props) => {
                // navigate(
                //   `/payroll/salary/revision/action?val=edit&id=${event.node.data.code}`
                // );
              },
            },
            {
              name: "Print",
              icon: '<span><i class="material-icons" style="font-size: 18px">print</i></span>',
              action: (props) => {
                // navigate(`/expense-claim/add?id=${event.node.data.id}`);
              },
            },
          ]
        : [
            {
              name: "View",
              icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
              action: (props) => {
                navigate(
                  `/exit-process/emp-details?val=view&id=${event.node.data.code}`
                );
              },
            },
            {
              name: "Edit",
              icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
              action: (props) => {
                // navigate(
                //   `/payroll/salary/revision/action?val=edit&id=${event.node.data.code}`
                // );
              },
            },
            {
              name: "Print",
              icon: '<span><i class="material-icons" style="font-size: 18px">print</i></span>',
              action: (props) => {
                // navigate(`/expense-claim/add?id=${event.node.data.id}`);
              },
            },
          ];
    return result;
  };
  return (
    <React.Fragment>
      <FormPageHeader
        componentName="List"
        pageName="Exit Process"
        currentPage="Exit Process"
      />
      <Dialog open={openModal} fullWidth maxWidth="sm" component="form">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Select Employee
            </Typography>
            <IconButton onClick={() => setOpenModal(false)}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}>
          <AgGridTable
            columnDefs={columnEmp}
            // onGridReady={onGridReady}
            gridRef={gridRef}
            rowData={rowDataEmp}
            editable={false}
            pagination={false}
            // onSelectionChanged={onSelectionChanged}
            // onRowDoubleClicked={onRowDoubleClicked}
          />
        </DialogContent>
        <DialogActions
          sx={{ background: "#373c42" }}
          className="justify-between px-16 sm:px-16"
        >
          <Box>&nbsp;</Box>
          <Button
            variant="contained"
            color="primary"
            type="button"
            onClick={() => setOpenModal(false)}
          >
            Select
          </Button>
        </DialogActions>
      </Dialog>

      <Stack direction={"row"} className={"items-end"} sx={{ padding: 2 }}>
        <Stack className="mr-16">
          Employee Code
          <StyledTextField
            type="text"
            className="w-[150px]"
            variant="outlined"
            name="year"
          />
        </Stack>
        <Stack className="mr-16">
          Employee Name
          <StyledTextField
            type="text"
            className="w-[150px]"
            variant="outlined"
            name="year"
          />
        </Stack>

        <Button
          color="warning"
          variant="contained"
          startIcon={
            <FuseSvgIcon size={18}>heroicons-outline:search</FuseSvgIcon>
          }
          sx={{ mr: 1 }}
        />
        <Button
          color="warning"
          variant="contained"
          startIcon={
            <FuseSvgIcon size={18}>heroicons-outline:plus-circle</FuseSvgIcon>
          }
          sx={{ mr: 1 }}
          onClick={() => setOpenModal(true)}
        >
          Add Employee Separation
        </Button>
      </Stack>

      <AgGridTable
        hideCheckbox={true}
        columnDefs={columnDefs}
        onGridReady={onGridReady}
        gridRef={gridRef}
        rowData={rowData}
        getContextMenuItems={getContextMenuItems}
        editable={false}
        pagination={false}
        onSelectionChanged={onSelectionChanged}
        // onRowDoubleClicked={onRowDoubleClicked}
      />
    </React.Fragment>
  );
};

export default ExitProcess;
